<template>
    <div class="toolbox-footer">
        <v-btn
                @click="save()"
                class="sr-button"
                text
                :loading="loading"
                :disabled="loading || getExceededLimits.length > 0 || objectsHasErrors"
        >
            Veröffentlichen
        </v-btn>
    </div>
</template>

<script>
  import { VBtn } from 'vuetify/lib'

  export default {
    components: {
      VBtn
    },
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      close () {
        this.$emit('close')
      },
      save () {
        this.$emit('save')
      }
    },
    computed: {
      getExceededLimits () {
        let exceeded = []
        for (let categoryId in this.item.currentObjectsByCategory) {
          if (this.item.currentObjectsByCategory[categoryId] > this.item.limitsByCategory[categoryId]) {
            exceeded.push(categoryId)
          }
        }

        return exceeded
      },
      objectsHasErrors () {
        return !!this.item.objects.find((item) => item.errors !== null)
      }
    }
  }
</script>

<style scoped>

</style>
